"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var REMOVE_FROM_MY_LIST_QUERY = "mutation AddToMyList($titleId: ID!) {\n  removeFromMyList(id: $titleId)\n}";
exports.default = REMOVE_FROM_MY_LIST_QUERY;
//# sourceMappingURL=removeTitleBookmark.js.map